module.exports = __webpack_public_path__ + "img/Group 12667.7ff57bfa.svg";